// API Configuration for different environments
const getApiBaseUrl = () => {
  // Check if we're in development
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8000';
  }
  
  // For production, check for Railway backend URL
  const railwayBackendUrl = process.env.REACT_APP_API_URL;
  if (railwayBackendUrl) {
    return railwayBackendUrl;
  }
  
  // For production (AWS Amplify), construct the backend URL
  // AWS Amplify backend will be deployed as a separate service
  const currentHost = window.location.hostname;
  
  // If running on AWS Amplify, construct backend URL
  if (currentHost.includes('amplifyapp.com')) {
    // Extract the app ID from the current domain
    const parts = currentHost.split('.');
    if (parts.length >= 3) {
      const appId = parts[0]; // e.g., "main" or "d1234567890"
      return `https://${appId}.amplifyapp.com/api`;
    }
  }
  
  // Fallback to localhost for development
  return 'http://localhost:8000';
};

export const API_BASE_URL = getApiBaseUrl();

// API Endpoints
export const API_ENDPOINTS = {
  ROOT: `${API_BASE_URL}/`,
  HEALTH: `${API_BASE_URL}/health`,
  DATA_SCIENCE_TOPICS: `${API_BASE_URL}/api/data-science/topics`,
  MACHINE_LEARNING_TOPICS: `${API_BASE_URL}/api/machine-learning/topics`,
  GENERATE_CHART: `${API_BASE_URL}/api/charts/generate`,
  SAMPLE_DATA: `${API_BASE_URL}/api/data/sample`,
};

// Helper function to make API calls
export const apiCall = async (endpoint: string, options: RequestInit = {}) => {
  try {
    const response = await fetch(endpoint, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });
    
    if (!response.ok) {
      throw new Error(`API call failed: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call error:', error);
    throw error;
  }
};
